import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  RenewConsentDateAtsCandidateDocument,
  RenewConsentDateAtsCandidateMutation,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  candidateId: number
  onClose: () => void
}
export const OverwriteDataConsentDateModal = ({ candidateId, onClose }: Props) => {
  const [renewConsentDateAtsCandidate, { loading }] = useMutation(
    RenewConsentDateAtsCandidateDocument,
    {
      extractorFn: (data: RenewConsentDateAtsCandidateMutation) =>
        data.atsMutations.renewConsentDateAtsCandidate,
    }
  )
  const onSubmit = async () => {
    const response = await renewConsentDateAtsCandidate({ variables: { id: candidateId } })
    const result = handleResult(response, () => undefined)

    if (result.success) {
      ;(app.setFlash({
        type: 'correct',
        message: i18n.t('ats.candidate_details.overwrite_consent_date_modal.success_message'),
      }),
        onClose())
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.candidate_details.overwrite_consent_date_modal.error_message'),
      })
    }
  }

  return (
    <Modal
      illustration="signature"
      title={i18n.t('ats.candidate_details.overwrite_consent_date_modal.title')}
      description={i18n.t('ats.candidate_details.overwrite_consent_date_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" disabled={loading} submit>
            {i18n.t('ats.candidate_details.overwrite_consent_date_modal.submit')}
          </Button>
        </Box>
      }
    />
  )
}
